module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab144-ec7a86f8d61fe87d5d15137085bb7f41.jpg";